<template>
    <el-tabs>
        <el-tab-pane label="Certificate">
            <el-button type="primary" v-if="awards.length > 0" @click="$emit('export', 'showTotal')"
                size="medium" style="margin-bottom: 10px;">Download the certificate</el-button>
            <p v-if="showNoAwards" style="margin-left: 20px;">You did not receive an award for this competition</p>
            <div id="showTotal">
                <div v-for="(item, index) in awards" :key="index" class="certContainer"
                    style="margin-bottom:10px;">
                    <img :src="horizontalStudentCertUrl" class="model_p" />
                    <div class="certifies">This certifies that</div>
                    <div class="student">{{ studentName }}</div>
                    <div class="school">{{ accountName }}</div>
                    <div class="has-achieved">has achieved the</div>
                    <div class="award">{{ item.award_lable }}</div>
                    <div class="in-project">in the {{ projectInfo.project_ename }}</div>
                    <p class="tips">We appreciate your faith in environmental protection and<br>your excellent performance.</p>
                    <div class="date">{{ certDate }}</div>
                    <div class="date-divider"></div>
                    <div class="date-label">Date</div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="Transcript">
            <el-button type="primary" @click="$emit('export', 'showTranscript')" size="medium"
                style="margin-bottom: 10px;">Download the transcript</el-button>
            <div id="showTranscript">
                <div class="transcriptContainer" style="margin-bottom:10px;">
                    <img :src="projectInfo.vertical_transcript" class="model_p" />
                    <div class="tips1 description" style="top: 380px;">This certificate is proudly presented to</div>
                    <div class="name"  style="top: 408px;">{{ studentName }}</div>
                    <div class="account" style="top: 465px;">{{ accountName }}</div>
                    <div class="tips1 description" style="top: 510px;">for participation in the</div>
                    <div class="tips1" style="top: 550px;font-size: 26px;font-weight: bold;">{{ projectInfo.project_ename }}</div>
                    <div class="score_section" v-if="scores.length > 0">
                        <div class="score_total">
                            <span>Academic Assessment : </span>
                            <span style="font-weight: 600;">{{ scores[0].total_score }} / 2000</span>
                        </div>
                        <table class="station_table" v-if="scores[0].team_section_scores && scores[0].team_section_scores.length">
                            <thead>
                                <tr>
                                    <th>Aquatics</th>
                                    <th>Forestry</th>
                                    <th>Soils</th>
                                    <th>Wildlife</th>
                                    <th>Current Issue</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td v-for="(ss, idx) in scores[0].team_section_scores" :key="idx">
                                        {{ ss.score }} / 400
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="date date-transcript">{{ certDate }}</div>
                    <div class="date-divider"></div>
                    <div class="date-label">Date</div>
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: 'AwardEnvirothon2026',
    props: {
        awards: Array,
        scores: Array,
        studentName: String,
        accountName: String,
        projectInfo: Object,
        horizontalStudentCertUrl: String,
        certDate: String,
        applicationId: String,
        showNoAwards: Boolean
    }
}
</script>

<style lang="scss" scoped>
.certContainer {
    position: relative;
    font-family: 'Lato', sans-serif;

    .model_p {
        width: 210mm;
        height: 295mm;
    }

    .certifies {
        width: 210mm;
        position: absolute;
        top: 480px;
        text-align: center;
        font-size: 15px;
        font-weight: normal;
        font-style: italic;
        color: #555;
    }

    .student {
        width: 210mm;
        position: absolute;
        top: 515px;
        text-align: center;
        font-size: 32px;
        font-weight: 700;
    }

    .school {
        width: 210mm;
        position: absolute;
        top: 560px;
        text-align: center;
        font-size: 20px;
        font-weight: 400;
    }

    .has-achieved {
        width: 210mm;
        position: absolute;
        top: 610px;
        text-align: center;
        font-size: 15px;
        font-weight: normal;
        font-style: italic;
        color: #555;
    }

    .award {
        width: 210mm;
        position: absolute;
        top: 645px;
        text-align: center;
        font-size: 28px;
        font-weight: 600;
    }

    .in-project {
        width: 210mm;
        position: absolute;
        top: 690px;
        text-align: center;
        font-size: 18px;
        font-weight: normal;
        color: #333;
    }

    .tips {
        width: 210mm;
        padding: 0 60px;
        box-sizing: border-box;
        position: absolute;
        top: 735px;
        text-align: center;
        font-size: 15px;
        line-height: 22px;
        font-weight: normal;
        font-style: italic;
        color: #555;
    }

    .date {
        position: absolute;
        top: 830px;
        left: 190px;
        width: 150px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
    }

    .date-divider {
        position: absolute;
        top: 863px;
        left: 190px;
        width: 150px;
        border-bottom: 1px solid #666;
    }

    .date-label {
        position: absolute;
        top: 872px;
        left: 190px;
        width: 150px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #666;
    }
}

.transcriptContainer {
    position: relative;
    font-family: 'Lato', sans-serif;

    .model_p {
        width: 210mm;
        height: 295mm;
    }

    .description {
        font-size: 15px!important;
        font-weight: normal!important;
        font-style: italic!important;
    }

    .tips1 {
        width: 210mm;
        color: #333;
        position: absolute;
        text-align: center;
        top: 355px;
        font-size: 20px;
        font-weight: normal;
    }

    .name {
        position: absolute;
        width: 210mm;
        top: 400px;
        font-size: 36px;
        font-weight: 600;
        text-align: center;
    }

    .account {
        text-align: center;
        width: 210mm;
        position: absolute;
        top: 450px;
        font-size: 24px;
        font-weight: 400;
    }

    .score_section {
        position: absolute;
        top: 600px;
        width: 210mm;
        text-align: center;
    }

    .score_total {
        font-size: 22px;
        font-weight: 400;
        margin-bottom: 18px;
    }

    .station_table {
        margin: 0 auto;
        border-collapse: collapse;
        font-size: 14px;

        th, td {
            border: 1px solid #999;
            padding: 6px 14px;
            text-align: center;
        }

        th {
            background: #f0f0f0;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-weight: 400;
        }
    }

    .date {
        position: absolute;
        top: 730px;
        left: 190px;
        width: 150px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
    }
    .date-transcript {
        position: absolute;
        top: 770px;
        left: 190px;
        width: 150px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
    }

    .date-divider {
        position: absolute;
        top: 795px;
        left: 190px;
        width: 150px;
        border-bottom: 1px solid #666;
    }

    .date-label {
        position: absolute;
        top: 800px;
        left: 190px;
        width: 150px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #666;
    }
}
</style>
